import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Link } from 'gatsby';
import {
  Wrapper,
} from '../common';
import { convertColorToHex } from '../../util/helpers';
import './CallToActionsBlock.scss';

const CallToActionsBlock = (props) => {
  const {
    data,
    isHome,
  } = props;
  const {
    primary,
  } = data;
  const {
    sectionTheme,
    leftActionHeadline,
    leftActionLink,
    leftActionSubtitle,
    rightActionHeadline,
    rightActionLink,
    rightActionSubtitle,
  } = primary;
  const sectionHex = sectionTheme ? convertColorToHex(sectionTheme) : null;
  let ref = null;
  let inView = null;
  if (isHome) {
    const [inViewRef, inViewBool] = useInView({
      /* Optional options */
      threshold: 0.2,
    });
    ref = inViewRef;
    inView = inViewBool;
    useEffect(() => {
      if (inView) document.documentElement.style.setProperty('--bg-colour', sectionHex);
    }, [inView]);
  }
  return (
    <div className="call-to-actions-block" ref={ref}>
      <Wrapper isBound isWide>
        <div className="cols">
          <div className="col col-left">
            <div className="illustration illustration-sun">
              <svg viewBox="0 0 254 216" xmlns="http://www.w3.org/2000/svg">
                <g fill="#EEEA00" fillRule="evenodd">
                  <path d="M94.968 151.989l4.409-23.397c2.817-8.45 8.093-15.541 15.829-21.273 11.603-8.597 19.472-13.206 36.8-13.394 4.764-.052 9.14-.416 13.127-1.092l9.634.444c12.672 5.099 20.788 10.738 24.35 16.917 5.341 9.268 13.994 36.542 4.063 56.744-9.931 20.202-20.966 24.534-34.581 33.437-13.615 8.903-36.592 1.231-49.765-7.393-12.075-7.905-16.53-14.087-18.782-19.437-.204-.486-.39-.966-.563-1.439-1.378-3.786-2.885-10.492-4.521-20.117zM72.061 23.366c.809-7.668 2.964-11.144 6.466-10.427 3.501.717 14.89 18.9 34.164 54.55l-5.277 1.921-35.353-46.044zM4.934 64.204L16.04 44.313l65.395 58.099-3.646 10.073zM164.457 3.198l8.296 8.62-10.898 49.608c-2.743.794-5.726.947-8.951.458-3.225-.49.626-20.052 11.553-58.686zM33.69 180.564l-6.362-17.482 46.003 3.054 1.398 3.84zM202.78 76.236l11.094 10.117 34.888-50.52-7.242-1.655z" />
                </g>
              </svg>
            </div>
            <Link
              key={leftActionLink.uid}
              to={leftActionLink.uid === 'home' ? '/' : `/${leftActionLink.uid}/`}
              className="call-to-action"
              aria-label={leftActionSubtitle.text}
            >
              <div className="text-container">
                <span className="headline">{leftActionHeadline.text}</span>
                <div className="subtitle styled-link">
                  <span>{leftActionSubtitle.text}</span>
                </div>
              </div>
            </Link>
            <div className="trailing-cloud-medium" />
          </div>
          <div className="col col-right">
            <div className="trailing-cloud-small" />
            <div className="illustration illustration-raindrops">
              <svg viewBox="0 0 240 257" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                  <path d="M22.144 40.989C7.86 57.725.716 69.754.716 77.074c0 10.98 1.286 20.153 21.428 19.3 20.143-.854 23.565-15.999 18.94-25.113-3.082-6.076-9.396-16.167-18.94-30.272zM78.4 162.725c21.142 24.77 31.713 42.572 31.713 53.406 0 16.25-1.902 29.826-31.713 28.563-29.811-1.263-34.876-23.677-28.032-37.166 4.563-8.993 13.907-23.927 28.032-44.803z" fill="#0A85E5" />
                  <path d="M207.245 171.285c-22 25.774-32.999 44.297-32.999 55.57 0 16.91 1.98 31.036 33 29.721 31.018-1.314 36.29-24.637 29.167-38.672-4.748-9.358-14.47-24.897-29.168-46.62zM100.319 63.908C86.033 80.645 78.89 92.673 78.89 99.993c0 10.98 1.285 20.153 21.428 19.3 20.142-.854 23.564-15.999 18.94-25.113-3.083-6.076-9.397-16.166-18.94-30.272z" fill="#00BEE0" />
                  <path d="M168.051.904c-14.285 16.737-21.428 28.765-21.428 36.085 0 10.98 1.286 20.153 21.428 19.3 20.143-.854 23.565-15.998 18.94-25.113-3.082-6.076-9.396-16.166-18.94-30.272z" fill="#0A85E5" />
                </g>
              </svg>
            </div>
            <Link
              key={rightActionLink.uid}
              to={rightActionLink.uid === 'home' ? '/' : `/${rightActionLink.uid}/`}
              className="call-to-action"
              aria-label={rightActionSubtitle.text}
            >
              <div className="text-container">
                <span className="headline">{rightActionHeadline.text}</span>
                <div className="subtitle styled-link">
                  <span>{rightActionSubtitle.text}</span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default CallToActionsBlock;
